import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Compass } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ActivityCard } from "@/components/ActivityCard";
import { Button } from "@/components/ui/button";
import { useFavorites } from "@/context/FavoritesContext";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";

const FavoritesPage = () => {
  const { favorites } = useFavorites();
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!favorites.length) {
      setItems([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    api.get("/businesses/by-ids", { params: { ids: favorites.join(",") } })
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, [favorites]);

  return (
    <div className="min-h-screen bg-[#FAF7F0]">
      <Navbar />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="favorites-page">
        <div className="flex items-center gap-3 mb-8">
          <span className="h-11 w-11 grid place-items-center rounded-2xl bg-rose-100 text-rose-500"><Heart size={22} className="fill-rose-500" /></span>
          <div>
            <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">{t("fav.title")}</h1>
            <p className="text-slate-600">{t("fav.subtitle")}</p>
          </div>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {Array.from({ length: 3 }).map((_, i) => <div key={i} className="h-72 rounded-2xl bg-slate-200 animate-pulse" />)}
          </div>
        ) : items.length === 0 ? (
          <div className="text-center py-24" data-testid="favorites-empty">
            <Heart className="mx-auto mb-3 text-slate-300" size={48} />
            <p className="font-semibold text-lg text-slate-700">{t("fav.empty")}</p>
            <p className="text-slate-500 text-sm mt-1">{t("fav.emptyHint")}</p>
            <Link to="/">
              <Button className="mt-6 rounded-full gap-2"><Compass size={16} /> {t("fav.browse")}</Button>
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="favorites-grid">
            {items.map((b, i) => <ActivityCard key={b.id} business={b} index={i} />)}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default FavoritesPage;
